import { Form, TimePicker } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import dayjs from "dayjs";
import { Styles } from "./styled";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

const TimeCustom = (props: IProps) => {
  const {
    item,
    isDisable,
    nameItem,
    style,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  return (
    <Styles
      style={style}
      background={styleColor?.background}
      color={styleColor?.color}
    >
      <div className="value_text_container">
        {isShowOnlyValue && value && dayjs(value).format(DATE_TIME_FORMAT.TIME)}
      </div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item?.is_required_field,
            message: `必須項目です`,
          },
        ]}
        className={className}
      >
        <TimePicker format={DATE_TIME_FORMAT.TIME} style={styleColor} />
      </Form.Item>
    </Styles>
  );
};
export default TimeCustom;
